<template>
  <section
    id="contact"
    class="py-5"
  >
    <v-container>
      <v-row>
        <v-col
          xs12
          md6
        >
          <v-form>
            <v-container pa-0>
              <v-row>
                <v-col
                  cols="12"
                  class="mb-4 grey--text"
                >
                  {{ $t('contact.description') }}
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="mailFirstName"
                    outlined
                    :label="$t('contact.first_name')"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="mailLastName"
                    outlined
                    :label="$t('contact.last_name')"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="mailEmail"
                    outlined
                    :label="$t('contact.email')"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="mailPhone"
                    :label="$t('contact.phone')"
                    outlined
                  />
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="mailSubject"
                    :label="$t('contact.subject')"
                    outlined
                  />
                </v-col>

                <v-col cols="12">
                  <v-textarea
                    v-model="mailBody"
                    :label="$t('contact.message')"
                    outlined
                  />
                </v-col>

                <v-col cols="12">
                  <v-btn
                    :block="$vuetify.breakpoint.xsOnly"
                    color="primary"
                    depressed
                    x-large
                    @click="sendMail"
                  >
                    {{ $t('contact.send') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-col>

        <v-col
          cols="12"
          md="6"
        >
          <v-container
            fluid
            pa-0
          >
            <v-row>
              <v-col
                cols="12"
                md="6"
                class="pa-0"
              >
                <v-card-title>{{ $t('contact.address') }}</v-card-title>
                <v-card-text>
                  <div>Avda. Errazuriz</div>
                  <div>Nº 1178 Of.97</div>
                  <div>Valparaíso</div>
                </v-card-text>
              </v-col>

              <v-col
                cols="12"
                md="6"
                class="pa-0"
              >
                <v-card-title>{{ $t('contact.contact_information') }}</v-card-title>
                <v-card-text>
                  <div>+56(32)2214570</div>
                  <div>+56(32)2235400</div>
                  <div>
                    <a href="#">secretaria@estudiogamboaycia.cl</a>
                  </div>
                </v-card-text>
              </v-col>

              <v-col cols="12">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3344.547997404155!2d-71.62555118481119!3d-33.04203688089289!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9689e1290ce4ed3d%3A0x5e3b685333b24d3!2sErr%C3%A1zuriz%201178%2C%20Valpara%C3%ADso!5e0!3m2!1ses!2scl!4v1580954182130!5m2!1ses!2scl"
                  width="100%"
                  height="400"
                  frameborder="0"
                  style="border:0"
                  allowfullscreen
                />
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
  export default {
    data: () => ({
      mailSubject: '',
      mailBody: '',
      mailFirstName: '',
      mailLastName: '',
      mailEmail: '',
      mailPhone: ''
    }),
    methods: {
      sendMail () {
        let subject = this.mailSubject
        let body = 'Nombre: ' + this.mailFirstName + '%0D%0A' + 'Apellido: ' + this.mailLastName + '%0D%0A' + 'Email: ' + this.mailEmail + '%0D%0A' + 'Telefono: ' + this.mailPhone + '%0D%0A' + this.mailBody
        window.open('mailto:secretaria@estudiogamboaycia.cl?subject=' + subject + '&body=' + body)
      }
    }
  }
</script>
